// extracted by mini-css-extract-plugin
export default {"searchBar":"style_searchBar__fl0Dp"};